import React from 'react'

import { getCurrentStep } from 'lib/helpers/registration/navigation'

// material ui
import Box from '@mui/material/Box'

// containers
import ErrorMessage from 'components/shared/ErrorMessage'

// components
import RegistrationStep from 'components/register/shared/RegistrationStep'
import Loading from 'components/atoms/Loading'
import Campers from 'components/account/Overview/Campers'
import Parents from 'components/account/Overview/Parents'
import EmergencyContacts from 'components/account/Overview/EmergencyContacts'
import PickupPeople from 'components/account/Overview/PickupPeople'
import NavButtons from 'components/register/shared/NavButtons'

const Overview = props => {
  const {
    loading,
    account,
    setModal,
    pathname // via withPathname
  } = props

  const { preferences } = account || {}
  const { onlineOnly = true } = preferences || {}
  const currentStep = getCurrentStep({ pathname, onlineOnly })

  return (
    <RegistrationStep>
      <Box mt={2}>
        <ErrorMessage />
      </Box>
      {!account || loading ? (
        <Loading />
      ) : (
        <>
          {currentStep.path === '/campers' && (
            <Campers
              buttonText='Add a new camper'
              buttonRoute='/campers/new'
              account={account}
              setModal={setModal}
              editable
            />
          )}
          {currentStep.path === '/parents' && (
            <Parents
              buttonText='Add a new parent / guardian'
              buttonRoute='/parents/new'
              account={account}
              setModal={setModal}
              editable
            />
          )}
          {currentStep.path === '/emergency_contacts' && (
            <EmergencyContacts
              buttonText='Add a new emergency contact'
              buttonRoute='/emergency_contacts/new'
              account={account}
              setModal={setModal}
              editable
            />
          )}
          {currentStep.path === '/pickup_people' && (
            <PickupPeople
              title='People authorized to pick up my camper'
              buttonText='Add a new pick-up person'
              buttonRoute='/pickup_people/new'
              account={account}
              setModal={setModal}
              editable
            />
          )}

          <NavButtons account={account} pathname={pathname} />
        </>
      )}
    </RegistrationStep>
  )
}

export default Overview
